var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _setup.currentData.createdDate
      ? _c("div", { staticClass: "mb-3" }, [
          _c("label", { staticClass: "form-sidebar-label" }, [
            _vm._v("Created"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex align-items-start" },
            [
              _setup.currentData.createdBy
                ? _c(_setup.UserAvatar, {
                    staticClass: "mt-1 me-2",
                    attrs: {
                      "user-id": _setup.currentData.createdBy,
                      "is-small": false,
                      "tooltip-placement": "right",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "small",
                [
                  _setup.currentData.createdBy
                    ? _c(_setup.UserName, {
                        attrs: {
                          id: _setup.currentData.createdBy,
                          "no-user-found-str": "",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _setup.getDate(_setup.currentData.createdDate * 1000)
                      ) +
                      "\n            "
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _setup.currentData.modifiedDate
      ? _c("div", { staticClass: "mb-3" }, [
          _c("label", { staticClass: "form-sidebar-label" }, [
            _vm._v("Modified"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex align-items-start" },
            [
              _setup.currentData.modifiedBy
                ? _c(_setup.UserAvatar, {
                    staticClass: "mt-1 me-2",
                    attrs: {
                      "user-id": _setup.currentData.modifiedBy,
                      "is-small": false,
                      "tooltip-placement": "right",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "small",
                [
                  _setup.currentData.modifiedBy
                    ? _c(_setup.UserName, {
                        attrs: {
                          id: _setup.currentData.modifiedBy,
                          "no-user-found-str": "<em>user not found</em>",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _setup.getDate(_setup.currentData.modifiedDate * 1000)
                      ) +
                      "\n            "
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }